import { render, staticRenderFns } from "./tabs-time-picker.vue?vue&type=template&id=c28f213c&scoped=true"
import script from "./tabs-time-picker.vue?vue&type=script&lang=js"
export * from "./tabs-time-picker.vue?vue&type=script&lang=js"
import style0 from "./tabs-time-picker.vue?vue&type=style&index=0&id=c28f213c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c28f213c",
  null
  
)

export default component.exports